import cookie from 'js-cookie'
export function getCurrentTimestamp() {
	return Math.floor(Date.now() / 1000)
}

export function getDetectLocationId() {
	return cookie.get('VNWSearchJob[city]')
}
